// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// third-party
import { useIntl } from 'react-intl';

export default function Footer() {
  const intl = useIntl();

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'space-between' },
        p: '24px 16px 16px',
        mt: 'auto',
        gap: { xs: 0.75, sm: 0 }
      }}
    >
      <Typography variant="caption" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
        &copy; {intl.formatMessage({ id: 'footer.allRightsReserved' })}{' '}
        <Link href="https://ayrodigital.ai/" target="_blank" rel="noopener noreferrer" underline="hover">
          Ayro Digital
        </Link>
      </Typography>

      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'center', gap: { xs: 0, sm: 1.5 } }}>
        <Link href="#" variant="caption" color="text.primary">
          {intl.formatMessage({ id: 'footer.aboutUs' })}
        </Link>
        <Typography variant="caption" color="text.secondary" aria-hidden="true" sx={{ display: { xs: 'inline', sm: 'none' }, mx: 0.75 }}>
          •
        </Typography>
        <Link href="#" variant="caption" color="text.primary">
          {intl.formatMessage({ id: 'footer.privacy' })}
        </Link>
        <Typography variant="caption" color="text.secondary" aria-hidden="true" sx={{ display: { xs: 'inline', sm: 'none' }, mx: 0.75 }}>
          •
        </Typography>
        <Link href="#" variant="caption" color="text.primary">
          {intl.formatMessage({ id: 'footer.terms' })}
        </Link>
      </Stack>
    </Stack>
  );
}
